import { createAction } from '@reduxjs/toolkit';
import EmployeeAction from 'types/employee/enums/Employee';

const cleanSelectedEmployees = createAction(EmployeeAction.CLEAN_SELECTED_EMPLOYEE);

export default cleanSelectedEmployees;
